import Select from 'components/Common/Form/Input/Select'
import React from 'react'

export function parseTailorMadeTourLengthValue(value: string): Tours.TailorMadeTourRequest['travelLength'] {
  const [from, to] = value.split('-')
  return {
    from: from === 'any' ? 'any' : Number(from),
    to: to === 'any' ? 'any' : Number(to),
  }
}

function parseDefaultValue(defaultValue?: Tours.TailorMadeTourRequest['travelLength']): string | undefined {
  if (!defaultValue) return
  return `${defaultValue.from}-${defaultValue.to}`
}

interface Props {
  name: string
  defaultValue?: Tours.TailorMadeTourRequest['travelLength']
}

function TailorMadeTourLengthInput({ name, defaultValue }: Props) {
  return <Select
    name={name}
    defaultValue={parseDefaultValue(defaultValue)}
    label="How long would you like your tour to be?"
    placeholder="Select number of days"
    required
  >
    <option value="any-any">Any duration</option>
    <option value="1-7">1 to 7 days</option>
    <option value="8-14">8 to 14 days</option>
    <option value="15-any">15+ days</option>
  </Select>
}

export default TailorMadeTourLengthInput
